import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FeedMessagesComponent from './FeedMessagesComponent';

export default class FeedMessagesContainer extends Component {
  /**
   * Render
   * @return {Object}
   */
  render() {
    const { type } = this.props;

    const title = type === 'feedMessages' ? 'Recently' : 'Messages';

    return (
      <FeedMessagesComponent
        onRefresh={this.handleRefresh}
        title={title}
        type={type}
      />
    );
  }
}

FeedMessagesContainer.displayName = 'FeedMessagesContainer';

FeedMessagesContainer.propTypes = {
  type: PropTypes.string.isRequired,
};